import { service } from '../axios';
// 获取分类树
export function getGovCategoryTree() {
    return service({
        url: '/gov/category/tree',
        method: 'get',
    });
}
// 新增分类
export function createGovCategory(data) {
    return service({
        url: '/gov/category/create',
        method: 'post',
        data,
    });
}
// 更新分类
export function updateGovCategory(data) {
    return service({
        url: '/gov/category/update',
        method: 'post',
        data,
    });
}
// 删除分类
export function deleteGovCategory(categoryId) {
    return service({
        url: `/gov/category/delete/${categoryId}`,
        method: 'post',
    });
}
export function runGovOperation(data) {
    return service({
        url: '/gov/runExecution',
        method: 'post',
        data
    });
}
/*单步执行数据治理任务*/
export function runGovStepExecution(data) {
    return service({
        url: '/gov/runStepExecution',
        method: 'post',
        data
    });
}
export function GovInventorySaveTask(data) {
    return service({
        url: '/dataGovInventoryTask/saveTask',
        method: 'post',
        data
    });
}
export function getGovInventoryGetTask(taskId) {
    return service({
        url: '/dataGovInventoryTask/getTask',
        method: 'get',
        params: { taskId }
    });
}
export function execGovInventoryTask(data) {
    return service({
        url: '/dataGovInventoryTask/execTask',
        method: 'post',
        data
    });
}
export function getGovInventoryItemPage(taskId, params) {
    return service({
        url: '/dataGovInventoryTask/getItemPage',
        method: 'get',
        params: { taskId, ...params }
    });
}
export function getMyGovInventoryItemPage(taskId, params) {
    return service({
        url: '/dataGovInventoryTask/getMyTasksPage',
        method: 'get',
        params: { taskId, ...params }
    });
}
export function batchGovInventoryItemAssignee(data) {
    return service({
        url: '/dataGovInventoryTask/batchUpdateAssignee',
        method: 'post',
        data
    });
}
export function saveGovInventoryItemSubmit(data) {
    return service({
        url: '/dataGovInventoryTask/saveGovInventoryItemSubmit',
        method: 'post',
        data
    });
}
export function deleteGovInventoryDetail(params) {
    return service({
        url: '/dataGovInventoryTask/deleteGovInventoryDetail',
        method: 'post',
        params
    });
}
